import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import replayIcon from '../../assets/player-icons/icon-replay.svg';

const RestartVideoButton = ({ dataId, onRestart }) => (
  <span className="restart-video-button futura-book">
    <button
      type="button"
      className="pa0 bn bg-transparent pr2-ns dib v-mid pointer"
      data-id={`${dataId}-restart-icon`}
      onClick={onRestart}
    >
      <img alt="watch again" style={{ height: '1.5rem' }} src={replayIcon} />
    </button>
    <button
      type="button"
      className="white pa0 bn bg-transparent pointer source-sans dn dib-ns"
      data-id={`${dataId}-restart-text`}
      onClick={onRestart}
    >
      <FormattedMessage {...messages.watchAgain} />
    </button>
  </span>
);

RestartVideoButton.propTypes = {
  dataId: PropTypes.string,
  onRestart: PropTypes.func,
};

RestartVideoButton.defaultProps = {
  dataId: '',
  onRestart: () => {},
};

export default RestartVideoButton;
